import { useEffect, useState } from "react";
import { apiRequest } from "../api";
import { StatusPill } from "../components";
import type { SupportCenterResponse } from "../types";

export function SupportSummary() {
  const [support, setSupport] = useState<SupportCenterResponse["support"] | null>(
    null,
  );

  useEffect(() => {
    void apiRequest<SupportCenterResponse>("/api/account/support-tickets")
      .then((response) => setSupport(response.support))
      .catch(() => setSupport(null));
  }, []);

  const unreadCount = support?.tickets.filter((ticket) => ticket.unread).length ?? 0;
  const latest = support?.tickets[0];
  return (
    <article className="dashboard-card support-summary-card">
      <div className="card-title-row">
        <div>
          <span className="card-kicker">客服</span>
          <h2>工单</h2>
        </div>
        {unreadCount ? <StatusPill tone="warn">{unreadCount} 条未读</StatusPill> : null}
      </div>
      {latest ? (
        <>
          <p className="support-summary-subject">{latest.subject}</p>
          <small className="support-summary-meta">
            {latest.status === "WAITING_FOR_SUPPORT"
              ? "等待客服回复"
              : latest.status === "WAITING_FOR_USER"
                ? "等待你的回复"
                : "已关闭"}
          </small>
          <a className="inline-action" href={`/contact?ticket=${latest.id}`}>
            打开工单中心
          </a>
        </>
      ) : (
        <>
          <p className="muted">遇到购买、账户或使用问题时，可以从联系我们页面创建工单。</p>
          <a className="inline-action" href="/contact">
            联系客服
          </a>
        </>
      )}
    </article>
  );
}
